import { Box, Button, Checkbox, FormControlLabel, Grid, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { Order } from "../../../Shared/GeneratedTypes";
import { Localizations } from "../../../Shared/sharedTypes";

interface propsType {
    order: Order;
    back: () => void;
    localizations: Localizations;
}
export default function CookieDisclosure({ order, back, localizations }: propsType) {
    return (
        <>
            <Grid item className="PhaseTopSection">
                <Box m={3}>
                    <Typography
                        dangerouslySetInnerHTML={{ __html: (order.customer.cookieDisclosures && order.customer.cookieDisclosures[order.cultureCode]) || localizations.cookieDisclosureNotSet }}
                    ></Typography>
                </Box>
            </Grid>
            <Grid item className="footer" alignContent="flex-start" justify="space-between" container direction="row">
                <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    onClick={() => { back(); }}
                >
                    {localizations.closeCookieDisclosure}
                </Button>
            </Grid>
        </>
    );
}